module.exports = __webpack_public_path__ + "img/Chaudiere.a948e3d8.svg";